import angular from 'angular';
import EsignDownloadEvidenceSummary from './esignDownloadEvidenceSummary';

export default angular
  .module('components.esignDownloadEvidenceSummary', [])
  .component('esignDownloadEvidenceSummary', EsignDownloadEvidenceSummary).name;
